define(["require", "exports", "hypo_elements/Typescripts/Configuration/Configuration", "jquery"], function (require, exports, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.openKlappmodulFromExternalTrigger = exports.openKlappmodul = exports.initKlappmodule = void 0;
    var klappmodulBodySelector = ".klappmodul_body";
    var klappmodulHeadClass = "klappmodul_head";
    var klappmodulHeadSelector = "." + klappmodulHeadClass;
    var isOpenState = "--is-open";
    var klappmodulHeadIsOpenClass = klappmodulHeadClass + isOpenState;
    var klappmodulHeadIsOpenSelector = klappmodulHeadSelector + isOpenState;
    function initKlappmodule($klappmodule) {
        $klappmodule.each(function (index, element) {
            var $klappmodul = $(element);
            var $klappmodulHead = $klappmodul.children(klappmodulHeadSelector);
            $klappmodulHead.not(klappmodulHeadIsOpenSelector).siblings(klappmodulBodySelector).hide();
            $klappmodulHead.off("click").click(function () {
                openKlappmodul($klappmodul);
            });
        });
    }
    exports.initKlappmodule = initKlappmodule;
    function openKlappmodul($klappmodul) {
        var $klappmodulHead = $klappmodul.find(klappmodulHeadSelector);
        var $klappmodulBody = $klappmodulHead.next(klappmodulBodySelector);
        $klappmodulBody
            .stop()
            .slideToggle(Configuration_1.configuration.klappmodulOpenCloseAnimationTimeInMs);
        $klappmodulHead.toggleClass(klappmodulHeadIsOpenClass);
    }
    exports.openKlappmodul = openKlappmodul;
    function openKlappmodulFromExternalTrigger($klappmodul) {
        var $klappmodulHead = $klappmodul.find(klappmodulHeadSelector);
        var $klappmodulBody = $klappmodulHead.next(klappmodulBodySelector);
        $klappmodulBody
            .stop()
            .slideDown(Configuration_1.configuration.klappmodulOpenCloseAnimationTimeInMs);
        $klappmodulHead.toggleClass(klappmodulHeadIsOpenClass);
    }
    exports.openKlappmodulFromExternalTrigger = openKlappmodulFromExternalTrigger;
    $(function () {
        initKlappmodule($(".klappmodul"));
    });
});
